import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BomHeader from "../../components/bom/BomHeader";
import ProductBomPanel from "../../components/bom/ProductBomPanel";
import BundleBomPanel from "../../components/bom/BundleBomPanel";
import PackagingBomPanel from "../../components/bom/PackagingBomPanel";
import SuppliesBomPanel from "../../components/bom/SuppliesBomPanel";
import BomSettingsDrawer from "../../components/bom/BomSettingsDrawer";
import BomChangeHistoryDrawer from "../../components/bom/BomChangeHistoryDrawer";
import {
    fetchBundleBomUi,
    fetchPackagingBomUi,
    fetchProductBomUi,
    fetchSuppliesBomUi,
    selectBomUi,
    setActiveBomTab,
    setBomSettingsOpen,
    setBomChangeHistoryOpen,
} from "../../slices/bomUiSlice";

const EMPTY_METRICS = {
    totalRows: 0,
    selectedRows: 0,
    totalCost: 0,
};

const BOM = () => {
    const dispatch = useDispatch();
    const { activeTab, data } = useSelector(selectBomUi);

    useEffect(() => {
        dispatch(fetchProductBomUi());
        dispatch(fetchPackagingBomUi());
        dispatch(fetchBundleBomUi());
        dispatch(fetchSuppliesBomUi());
    }, [dispatch]);
    const [metricsByTab, setMetricsByTab] = useState({
        product: EMPTY_METRICS,
        bundle: EMPTY_METRICS,
        packaging: EMPTY_METRICS,
        supplies: EMPTY_METRICS,
    });

    const counts = useMemo(
        () => ({
            product: (data.products || []).length,
            bundle: (data.bundles || []).length,
            packaging: (data.packaging || []).length,
            supplies: (data.supplies || []).length,
        }),
        [data]
    );

    const activeMetrics = metricsByTab[activeTab] || EMPTY_METRICS;

    const onProductMetricsChange = useCallback((nextMetrics) => {
        setMetricsByTab((current) => ({ ...current, product: nextMetrics }));
    }, []);
    const onBundleMetricsChange = useCallback((nextMetrics) => {
        setMetricsByTab((current) => ({ ...current, bundle: nextMetrics }));
    }, []);
    const onPackagingMetricsChange = useCallback((nextMetrics) => {
        setMetricsByTab((current) => ({ ...current, packaging: nextMetrics }));
    }, []);
    const onSuppliesMetricsChange = useCallback((nextMetrics) => {
        setMetricsByTab((current) => ({ ...current, supplies: nextMetrics }));
    }, []);

    return (
        <>
            <main className="flex h-full min-h-screen w-full flex-col bg-gray-50">
                <BomHeader
                    activeTab={activeTab}
                    counts={counts}
                    onChangeTab={(tabId) => dispatch(setActiveBomTab(tabId))}
                    onOpenSettings={() => dispatch(setBomSettingsOpen(true))}
                    onOpenChangeHistory={() => dispatch(setBomChangeHistoryOpen(true))}
                />
                <div className="">
                    <div className="min-h-0 flex-1">
                        {activeTab === "product" ? (
                            <ProductBomPanel onMetricsChange={onProductMetricsChange} metrics={activeMetrics} />
                        ) : null}
                        {activeTab === "bundle" ? (
                            <BundleBomPanel onMetricsChange={onBundleMetricsChange} metrics={activeMetrics} />
                        ) : null}
                        {activeTab === "packaging" ? (
                            <PackagingBomPanel onMetricsChange={onPackagingMetricsChange} metrics={activeMetrics} />
                        ) : null}
                        {activeTab === "supplies" ? (
                            <SuppliesBomPanel onMetricsChange={onSuppliesMetricsChange} metrics={activeMetrics} />
                        ) : null}
                    </div>
                </div>
            </main>
            <BomSettingsDrawer />
            <BomChangeHistoryDrawer />
        </>
    );
};

export default BOM;